import { StyleSheet } from 'aphrodite';
import { brandPrimaryActive, nodeBorderBlue, white } from '../../../../styles/colors';

const spinAnimation = {
	from: { transform: 'rotate(0deg)' },
	to: { transform: 'rotate(360deg)' },
};

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		gap: 8,
		zIndex: 1000,
	},
	fab: {
		width: 40,
		height: 40,
		borderRadius: '50%',
		backgroundColor: '#000000',
		color: white,
		border: `2px solid ${nodeBorderBlue}`,
		cursor: 'pointer',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
		transition: 'all 0.2s ease',
		':hover': {
			backgroundColor: nodeBorderBlue,
			transform: 'scale(1.1)',
			boxShadow: '0 6px 16px rgba(44, 101, 246, 0.5)',
		},
		':active': {
			transform: 'scale(0.95)',
		},
		':disabled': {
			opacity: 0.6,
			cursor: 'not-allowed',
			transform: 'none',
		},
		':focus': {
			outline: '3px solid rgba(44, 101, 246, 0.4)',
			outlineOffset: 2,
		},
	},
	fabLoading: {
		pointerEvents: 'none',
	},
	fabActive: {
		backgroundColor: brandPrimaryActive,
		transform: 'scale(1.05)',
	},
	fabHighlighted: {
		transform: 'scale(1.3)',
		boxShadow: '0 0 20px rgba(44, 101, 246, 0.6), 0 6px 16px rgba(44, 101, 246, 0.5)',
		backgroundColor: nodeBorderBlue,
		borderColor: nodeBorderBlue,
		transition: 'all 0.15s ease-out',
	},
	spinner: {
		width: 20,
		height: 20,
		animationName: spinAnimation,
		animationDuration: '1s',
		animationIterationCount: 'infinite',
		animationTimingFunction: 'linear',
	},
	tooltip: {
		fontSize: 11,
		fontWeight: 500,
		color: '#6b7280',
		backgroundColor: white,
		padding: '3px 6px',
		borderRadius: 4,
		boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
		whiteSpace: 'nowrap',
	},
});
